import React from 'react';
import '../styles/ShareConfirmDialog.css';

function ShareConfirmDialog({ isOpen, onClose, onConfirm, title }) {
  if (!isOpen) return null;

  return (
    <>
      <div className="share-confirm-overlay" onClick={onClose} />
      <div className="share-confirm-dialog">
        <h3>Share Prompt</h3>
        <p>
          Are you sure you want to share "{title}"? 
          This will create a public link that anyone can access.
        </p>
        <div className="share-confirm-actions">
          <button 
            className="confirm-button"
            onClick={onConfirm}
          >
            Yes, make it public
          </button>
          <button 
            className="cancel-button"
            onClick={onClose}
          >
            Cancel
          </button>
        </div>
      </div>
    </>
  );
}

export default ShareConfirmDialog; 